<template>
  <div class="baseButtonGroup">
    <div class="buttonGroup">
      <slot name="firstButton" />
      <slot name="middleButtons" />
      <slot name="lastButton" />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BaseButtonGroup",
});
</script>
<style scoped lang="scss">
.baseButtonGroup {
  width: fit-content;
  padding: 4px;
  border-radius: $border-radius-m;
  @include themed() {
    background: t($grey-05);
  }

  .buttonGroup {
    display: flex;
    flex-direction: row;
    gap: 2px;

    :deep(button.base-button.none.main) {
      border: none;
      border-radius: $border-radius-m;
      transition: all 0.15s ease;
      @include themed() {
        background: t($grey-05);
      }

      &.main,
      &.important {
        @include themed() {
          &:hover {
            background: t($grey-05);
          }
        }
      }

      &.active {
        @include themed() {
          background: t($bg);
          color: t($primary);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
        }

        &:hover {
          @include themed() {
            background: t($bg);
          }
        }
      }
    }
  }
}
</style>
